export default __webpack_public_path__ + "cae574d204db5852bbd646cf1dd71cc9.png";